import { render, staticRenderFns } from "./Picture.vue?vue&type=template&id=810cc6da&scoped=true&"
import script from "./Picture.vue?vue&type=script&lang=js&"
export * from "./Picture.vue?vue&type=script&lang=js&"
import style0 from "./Picture.vue?vue&type=style&index=0&id=810cc6da&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "810cc6da",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('810cc6da')) {
      api.createRecord('810cc6da', component.options)
    } else {
      api.reload('810cc6da', component.options)
    }
    module.hot.accept("./Picture.vue?vue&type=template&id=810cc6da&scoped=true&", function () {
      api.rerender('810cc6da', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/weeklylogin/campaign/components/Picture.vue"
export default component.exports